import { InspectionDocument } from '../Inspections/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { inspectionCategoriesPullQueryBuilder, InspectionCategoryDocument } from './queryBuilder';

export function inspectionCategoriesFamilyMember(
  configBuilder: ConfigBuilder,
  inspections: FamilyMember<InspectionDocument>,
): FamilyMember<InspectionCategoryDocument> {
  const syncConfig = configBuilder<InspectionCategoryDocument>(
    RxdbCollectionNameV2.INSPECTION_CATEGORIES,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, inspectionCategoriesPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy set the syncInterval to LiveInterval.MINUTES_15
  return create(RxdbCollectionNameV2.INSPECTION_CATEGORIES, replicationState, [inspections]);
}
